export default __webpack_public_path__ + "static/media/292.46d6aa78.png";